import { useTranslation } from 'react-i18next';

import { useCostDecimals } from 'pricing/hooks';
import { useGetTradeAgreements } from 'quotes/hooks';
import { ISelectedSpaFormValue, TTradeAgreementsRequest } from 'quotes/types';

import {
  findHeldAgreement,
  getSelectedSpaNoLongerOfferedMessage,
  getTransientLine,
  isTradeAgreementsLineError,
} from '../utils';

/**
 * Never fetches, so a list that is unknown, loading or failed claims nothing.
 */
export const useSelectedSpaNotOfferedMessage = (
  selectedSpa: ISelectedSpaFormValue | null | undefined,
  requestPayload: TTradeAgreementsRequest | null,
  isMarkedNotOffered = false
): string | null => {
  const { t } = useTranslation();

  const costDecimals = useCostDecimals();
  const { lines, isSuccess } = useGetTradeAgreements(requestPayload, false);

  const line = getTransientLine(lines);
  const isNotOfferedInCache =
    isSuccess &&
    !isTradeAgreementsLineError(line) &&
    !findHeldAgreement(line?.tradeAgreements ?? [], selectedSpa);

  if (!selectedSpa?.spaCostSource || (!isMarkedNotOffered && !isNotOfferedInCache)) {
    return null;
  }

  const { key, values } = getSelectedSpaNoLongerOfferedMessage(selectedSpa, costDecimals);

  return t(key, values);
};
